<!--
//================================================================================
// ID:BC013C2
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC013C2
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2023/04/20 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/09/27 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
  <main class="contents__main">
	<div class="contents__main--mosikomi" />
	<error-message />
		<!--◆編集エリア START◆-->
		<div id="ichiran">
			<p></p><hr>
			<div style="margin-bottom: 8px; margin-top: 15px;">
				<span>取込み元：</span>
				<label class="label-style contents__kaigyo--css"><a id="download" :tabindex="-1" @click="doDownload" style="cursor: pointer;">{{form.txFileName}}</a></label>
			</div>
			<p></p><hr>
			<input type="button" value="戻る" class="contents__btn--cancel" style="margin-bottom: 15px;" @click="reSearch"/>
			<br />
			<h2 class="contents__h2">取込み結果</h2>
			<div align="center">
				<textarea name="kanso" id="errMessageArea" rows="10" cols="40" class="contents__input--text contents__input--csv" readonly="readonly" />
			</div>
		</div>
		<!--◆編集エリア END◆-->
  </main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';

import { STORE_VIEW_PROGRESS, STORE_ERROR_CLEAR, STORE_DATA_ADD_DATA, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { HTTP_STATUS } from '@/const/const.js';
import { co_post, co_downloadFile } from '@/common/ajaxUtility.js';
import { co_errorDialog } from '@/common/dialogUtility.js';
import { co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC013_SEARCHERR, PATH_BC013_DOWNLOAD } from '@/const/route.js';

export default {
	name: "BC013C2",
	components: {
		'error-message': ErrorMessage
	},
	data: function () {
		return {
			form: {
				dtTorikomi: '',
				nuRenban: '',
				txFileName: '',
				txFilePath: '',
				fgDel: '',
				meisaiList:[],				
				txErrMessageAll: '',
			},
			dtTorikomi: '',
			nuRenban: '',
			txFileName: '',
			txFilePath: '',
		};
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC013C2');
		this.dtTorikomi = params.dtTorikomi;
		this.nuRenban = params.nuRenban;
		this.txFileName = params.txFileName;
		this.txFilePath = params.txFilePath;

		// 画面間パラメータを削除
		co_clearParam('BC013C2');

		this.form.meisaiList = this.meisaiList;

		this.form.dtTorikomi = this.dtTorikomi;
		this.form.nuRenban = this.nuRenban;
		this.form.txFileName = this.txFileName;
		this.form.txFilePath = this.txFilePath;
		this.form.fgDel = "0";

		// 検索処理実施
		this.search();

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {
		// 検索処理
		search: async function() {

			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			let args = {
				'dtTorikomi' : this.form.dtTorikomi,
				'nuRenban' : this.form.nuRenban,
				'fgDel' : this.form.fgDel
			};
			let list = await co_post(PATH_BC013_SEARCHERR, args);

			if(list.meisaiList === null || list.meisaiList.length === 0){
				co_errorDialog("検索結果がありません。", this.doErrDaialog);
				return;
			}

			// 明細単位に改行を挿入
			this.form.txErrMessageAll = '';
			for (let i = 0; i < list.meisaiList.length; i++) {
				if (i == 0) {
					this.form.txErrMessageAll = list.meisaiList[i].txErrMessage;
				} else {
					this.form.txErrMessageAll = this.form.txErrMessageAll + '\n' + list.meisaiList[i].txErrMessage;
				}
			}

			// 取込み結果を表示
			let errMessageArea = document.getElementById('errMessageArea');
			errMessageArea.value = this.form.txErrMessageAll;

			// 入力値保持
			this.$store.commit(STORE_DATA_ADD_DATA, {id:'BC013C2', data:this.form});

			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);

		},
		// エラー時の確認ダイアログ「はい」ボタン押下時処理
		doErrDaialog: function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 住宅状況情報CSV取込み画面へ遷移
				co_toTrans('BC013C1');
				return;
			}
		},
		doDownload: async function () {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);
			
			await co_downloadFile(PATH_BC013_DOWNLOAD, this.form, function (res, handle) {
				if(res.status == HTTP_STATUS.OK) {
					return handle(res);
				}
			}, this.form.txFileName);
			
			// ローディング表示終了
			this.$store.commit(STORE_VIEW_PROGRESS, false);
		},
		reSearch: function () {
			// 住宅状況情報CSV取込み画面に遷移
			co_toTrans('BC013C1');
		}
	}
}
</script>

<style scoped>

/*PAGE START*/
	#ichiran {
		margin: 8px;
	}
	#link {
		text-decoration: none;
	}
	#meisaiheader2 {
		background-color: #e7f5ff;
		color: #00008b;
	}
	#meisaitd {
		text-align: center;
	}
	#meisaijyusho{
		padding-left: 1%;
	}
	#meisaiodd {
		background-color: #eeeeee;
		text-align: senter;
	}
	#meisaititle1{
		width: 100%;
	}
	#list{
		width: 100%;
	}
	th,td{
		padding-top: 1%;
		padding-bottom: 1%;
	}
	#meisaitdleft {
		text-align: left;
	}
	.label-style {
		color: #0000EE;
		text-decoration:underline;
		text-decoration-color:#0000EE;
	}
	.contents__hissu1 {
		background-color: #fe0000;
		color: #ffffff;
		font-size: 12px;
		border-radius: 3px;
		padding : 2px 2px;
		margin-right: 20px;
		margin-bottom: 2px;
		position: relative;
		bottom: 2px;
	}
	.contents__input--csv {
		width: 99%;
		font-family: sans-serif;
		font-size: 16px;
		color: #262626;
	}
	/* 通常ボタン */
	.contents__btn--normal {
		padding: 0.1em 1.6em;
	}

	/* 確定ボタン */
	.contents__btn--confirm {
		padding: 0.1em 1.6em;
		margin-left: 200px;
	}

	/* キャンセルボタン */
	.contents__btn--cancel {
		padding: 0.1em 1.6em;
	}
/*PAGE END*/

/* IE対応 */
@media all and (-ms-high-contrast: none) {
	.contents__main--mosikomi {
		margin-top: 50px !important;
	}
}

</style>
